// eslint-disable-next-line
import React, { Suspense, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import queryString from "query-string";
import HelpBlockImg from "../../_assets/_images/helpBlock.png";
import SkeletonTableList from "../skeleton/SkeletonTableList.jsx";
import FooterPagination from "../_footerpagination/FooterPagination";
import { makeStyles } from "@material-ui/core/styles";
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import { DeleteConfirmDialog } from '../updateHandlers/DeleteDialog'
import {
  Grid,
  Tooltip,
  TableContainer,
  TableHead,
  Table,
  TableCell,
  TableBody,
  TableRow,
  Button,
  Typography,
  Paper,
  Dialog,
  DialogContent,
  DialogActions,
  Collapse,
  IconButton,
  Box,
  Snackbar,
} from "@material-ui/core";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import {
  fetchSelectScopedAnomalyRule,
  fetchSpecificAnomalyRule,
  selectAnomalyRulePageSelect,
} from "../../_redux/_actions/selectScopedAnomalyRuleAction";
import SelectScopeMenu from "../selectScope/SelectScopeMenu.jsx";
import { history } from "../../_redux/_store/history.js";
import CreateScopedAnomalyRule from "../anomalyRule/CreateScopedAnomalyRule.jsx";
import useDebounce from "../../utilities/useDebounce.js";
import { persistFilterData } from "../../_redux/_actions/detailsPersistActions";
import SkeletonPaper from "../skeleton/SkeletonPaper";
import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/Delete'
import EditScopedAnomalyRule from './EditScopedAnomalyRule'
import {deleteScopedAnomalyRule} from '../../_redux/_actions/scopedAnomalyRuleActions'
import { BreadcrumbDispatch } from "../../App";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  detailsPaper: {
    backgroundColor: "#F6F6F6",
    padding: "30px 0px 30px 15px",
    width: "100%",
  },
  containerPaper: {
    height: "100%",
    padding: "30px",
    opacity: "1",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  table: {

  },
}));

const SelectScopedAnomalyRuleComponent = () => {
  const selectScopedAnomalyRuleResponse = useSelector(
    (state) => state.selectScopedAnomalyRule
  );
  const scopedAnomalyRuleResponse = useSelector(
    (state) => state.scopedAnomalyRule
  );
  const queryValues = queryString.parse(history.location.search);
  const {machine_type, hmi_type} = queryValues;
  const anomalyRuleId = queryValues.anomalyRuleId;
  const dispatch = useDispatch();
  const classes = useStyles();
  const [rules, setRules] = useState("");
  const [currentPage, setcurrentPage] = useState(1);
  const [page, setPage] = useState(1);
  const [rulesPerPage] = useState(8);
  const [filteredData, setFilteredData] = useState("");
  const [filterScopeData, setfilterScopeData] = useState("");
  const [deleteData, setDeleteData] = useState("");
  const [currentRule, setCurrentRule] = useState("");
  const [scopedAnomalyOpen, setScopedAnomalyOpen] = React.useState(false);
  const [createSuccess, setCreateSuccess] = useState(false);
  const [createdScope, setCreatedScope] = useState([]);
  const [selectScopedAR, setSelectScopedAR] = useState(true);
  const [editScopedAnomalyRule, setEditScopedAnomalyRule] = useState(false)
  const [dataToEdit, setDataToEdit] = useState('')
  const [editScopedAnomalySuccess, setEditScopedAnomalySuccess] = useState(false)
  const [editScopedAnomalyFailure, setEditScopedAnomalyFailure] = useState(false)
  const [open, setOpen] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [updateSuccess, setUpdateSuccess] = useState(false);
  const [deleteSuccess, setDeleteSuccess] = useState(false);
  const debounce = useDebounce();

  // w-disable-next-line
  useEffect(() => {
    dispatch(
      fetchSelectScopedAnomalyRule({
        anomaly_rule_id: anomalyRuleId,
        machine_type: machine_type,
        hmi_type:hmi_type
      })
    );
    dispatch(fetchSpecificAnomalyRule(anomalyRuleId, machine_type, hmi_type));
    dispatch(selectAnomalyRulePageSelect("scopedAnomalyRule"));
  }, []);

  useEffect(() => {
    if (selectScopedAnomalyRuleResponse.selectScopedAnomalyRule) {
      setRules(selectScopedAnomalyRuleResponse.selectScopedAnomalyRule);
      setFilteredData(selectScopedAnomalyRuleResponse.selectScopedAnomalyRule);
    }
  }, [selectScopedAnomalyRuleResponse]);

  useEffect(() => {
    const indexOfLastRule = currentPage * rulesPerPage;
    const indexOfFirstRule = indexOfLastRule - rulesPerPage;
    setCurrentRule(filteredData.slice(indexOfFirstRule, indexOfLastRule));
  }, [filteredData, currentPage]);

  //setting current page
  const paginate = (pageNumber) => {
    setcurrentPage(pageNumber);
  };

  const handleChange = (event, value) => {
    setPage(value);
    paginate(value);
  };

  //Edit scoped anomaly rule
  const handleEdit = (data) => {
    setEditScopedAnomalyRule(true)
    setDataToEdit(data)
  }
  const handleUpdateSuccess = () => {
    dispatch(
      fetchSelectScopedAnomalyRule({
        anomaly_rule_id: anomalyRuleId,
        machine_type: machine_type,
        hmi_type:hmi_type
      })
    );
    setUpdateSuccess(true)
     setEditScopedAnomalySuccess(false)
  }

  //close the edit pop up
  const handleClose = () => {
    setEditScopedAnomalyRule(false)
  }
  //Delete socped anomaly rule
  const handleConfirm = (row) => {
    setDeleteData(row)
    setOpenDelete(!openDelete)
  }
  const handleDelete = () => {
   const body = { anomaly_rule_id: deleteData.anomaly_rule_id, scope: deleteData.scope }
   dispatch(deleteScopedAnomalyRule(body, machine_type,hmi_type))
   setDeleteSuccess(true)
  }

  useEffect(() => {
    if (scopedAnomalyRuleResponse.deleteSuccess) {
      dispatch(
        fetchSelectScopedAnomalyRule({
          anomaly_rule_id: anomalyRuleId,
          machine_type: machine_type,
          hmi_type:hmi_type
        })
      );
    }
  }, [scopedAnomalyRuleResponse.deleteSuccess])

  const getScopeData = (scopeData) => {
    var filterScopeDataValue = scopeData.split(/[:]/);
    setfilterScopeData(filterScopeDataValue);
    dispatch(persistFilterData(filterScopeDataValue));
    var tempScope = scopeData ? `global:${scopeData}` : "";
    const params = {
      anomaly_rule_id: anomalyRuleId,
      machine_type: machine_type,
      hmi_type:hmi_type,
      scope: filterScopeDataValue.length > 1 ? tempScope : '',
    };
    dispatch(fetchSelectScopedAnomalyRule(params));
  };

  const handleScopedAnomalyDialog = () => {
    setScopedAnomalyOpen(!scopedAnomalyOpen);
  };

  const handleConfirmUpdate = (row) => {
    history.push(
      `/rules/select_anomaly_rule/select_scoped_anomaly_rule/scoped_anomaly_rule_configuration?machine_type=${machine_type}&hmi_type=${hmi_type}&anomalyRuleId=${anomalyRuleId}&scope=${row.scope}`
    );
  };

  //Successful creation of scope
  const createSuccessFlag = (anomalyRuleId, scope) => {
    setScopedAnomalyOpen(!scopedAnomalyOpen);
    setCreatedScope({'rule': anomalyRuleId, 'scope': scope})
    setCreateSuccess(true);
  };

  const handleCreateSuccessDialog = () => {
    setCreateSuccess(false);
    debounce(() =>
      history.push(
        `/rules/select_anomaly_rule/select_scoped_anomaly_rule/scoped_anomaly_rule_configuration?machine_type=${machine_type}&hmi_type=${hmi_type}&anomalyRuleId=${createdScope.rule}&scope=${createdScope.scope}`
      )
    );
  };

  const CreateSuccessDialog = () => {
    return (
      <Dialog
        open={createSuccess}
        onClose={handleCreateSuccessDialog}
        style={{
          padding: "20px",
        }}
      >
        <DialogContent>Scoped Anomaly Rule created successfully</DialogContent>
        <DialogActions>
          <Button onClick={handleCreateSuccessDialog} color='primary' autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  return (
    <Grid container spacing={2}>
      <BreadcrumbDispatch />
      <Grid item md={9} style={{ padding: "12px" }}>
        <Paper className={classes.containerPaper}>
          <Grid container direction='column' spacing={3}>
            <Grid item container>
              <Grid item container xs={9}>
                <Typography className='text-secondary' variant='h5'>
                  Select Scoped Anomaly Rule
                </Typography>

                <Tooltip title='question'>
                  <HelpOutlineIcon className={classes.icon} />
                </Tooltip>
              </Grid>
              <Grid item xs={3}>
                <Button
                  variant='outlined'
                  onClick={() => handleScopedAnomalyDialog()}
                >
                  + CREATE NEW
                </Button>
              </Grid>
            </Grid>
            <Grid item container>
              <Paper className={classes.detailsPaper} elevation={0}>
                <Grid key={`anomalyDetail`} item container spacing={2}>
                  {selectScopedAnomalyRuleResponse.loading ? (
                    <SkeletonPaper row={1} />
                  ) : null}
                  {!selectScopedAnomalyRuleResponse.loading &&
                    selectScopedAnomalyRuleResponse.specificAnomalyRule &&
                    selectScopedAnomalyRuleResponse.specificAnomalyRule
                      .map((anomaly,id) => (
                        <React.Fragment key={`rule-${id}`}>
                        <Grid container item xs={12}>
                          <Grid item md={5}>
                            <Typography variant='subtitle2'>
                              Anomaly Type
                            </Typography>
                          </Grid>
                          <Grid item md={1}>
                            -
                          </Grid>
                          <Grid item md={6}>
                            <Typography className='black-text'>
                              {anomaly.anomaly_type_id}
                            </Typography>
                          </Grid>
                        </Grid>
                        <Grid container item xs={12}>
                          <Grid item md={5}>
                            <Typography variant='subtitle2'>Signals</Typography>
                          </Grid>
                          <Grid item md={1}>
                            -
                          </Grid>
                          <Grid item md={6}>
                            {anomaly.signals &&
                              anomaly.signals.map((row, id) => (
                                <Typography
                                  className='black-text wordBreak'
                                  key={`signal-${id}`}
                                >
                                  {row.name}
                                </Typography>
                              ))}
                          </Grid>
                        </Grid>
                        <Grid container item xs={12}>
                          <Grid item md={5}>
                            <Typography variant='subtitle2'>
                              Machine Type
                            </Typography>
                          </Grid>
                          <Grid item md={1}>
                            -
                          </Grid>
                          <Grid item md={6}>
                            <Typography
                              className='black-text wordBreak'
                            >
                              {machine_type}
                            </Typography>
                          </Grid>
                        </Grid>
                        <Grid container item xs={12}>
                          <Grid item md={5}>
                            <Typography variant='subtitle2'>
                              HMI Type
                            </Typography>
                          </Grid>
                          <Grid item md={1}>
                            -
                          </Grid>
                          <Grid item md={6}>
                            <Typography
                              className='black-text wordBreak'
                            >
                              {hmi_type}
                            </Typography>
                          </Grid>
                        </Grid>
                        </React.Fragment>
                      ))}
                </Grid>
              </Paper>
            </Grid>
            <Grid item container>
              <Typography>
                Select or define a Scoped Anomaly Rule under the scope and
                proceed to configure the parameters for scoped anomaly rule.
              </Typography>
            </Grid>
            <Grid item container>
              <SelectScopeMenu selectScopedPage ={selectScopedAR} getScopeData={getScopeData} />
            </Grid>
            <Grid item container>
              <TableContainer component={Paper}>
                <Table className={classes.table} aria-label='simple table'>
                  <TableHead>
                    <TableRow style={{ backgroundColor: "grey" }}>
                      <TableCell style={{ color: "white" }}>
                        Anomaly_rule_id
                      </TableCell>
                      <TableCell align='left' style={{ color: "white" }}>
                        Scope
                      </TableCell>
                      <TableCell align='left' style={{ color: "white" }}>
                        Parameters
                      </TableCell>
                      <TableCell align='left' style={{ color: "white" }}>
                        Note Text
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {selectScopedAnomalyRuleResponse.loading ? (
                      <SkeletonTableList count={4} />
                    ) : null}
                    {currentRule && !selectScopedAnomalyRuleResponse.loading
                      ? currentRule.map((row, id) => (
                          <TableRow
                            hover
                            style={{ height: 10 }}
                            key={`current-rule-${id}`}
                          >
                            <TableCell component='th' scope='row'>
                              <IconButton
                                aria-label='expand row'
                                size='small'
                                onClick={() => setOpen((prevState => ({...prevState, [id]: !prevState[id]})))}
                              >
                                {open ? (
                                  <KeyboardArrowDownIcon />
                                ) : (
                                  <KeyboardArrowRightIcon />
                                )}
                              </IconButton>
                              {row.anomaly_rule_id ? row.anomaly_rule_id : null}
                            </TableCell>
                            <TableCell align='left'>
                              <p> {row.scope ? row.scope : null}</p>
                              <Collapse in={open[id]} timeout='auto' unmountOnExit>
                                <Grid
                                  container
                                  direction='row'
                                  style={{ marginLeft: '0.5em' }}
                                >
                                  <Grid item>
                                    <Button
                                      style={{ padding: 5, marginLeft: 0 }}
                                      onClick={() => handleConfirmUpdate(row)}
                                      color='primary'
                                      className='btn-primary'
                                    >
                                      Confirm
                                    </Button>
                                  </Grid>
                                  <Grid style={{ marginLeft: '0.5em' }}>
                                    <Button
                                    onClick={() => handleEdit(row)}
                                    >
                                      <EditIcon style={{ fill: 'grey' }} />
                                    </Button>
                                  </Grid>
                                  <Grid item style={{ marginLeft: '0.5em' }}>
                                    <Button
                                    onClick={() => handleConfirm(row)}
                                    >
                                      <DeleteIcon style={{ fill: 'grey' }} />
                                    </Button>
                                  </Grid>
                                </Grid>
                              </Collapse>
                            </TableCell>
                            <TableCell align='left'>
                              <span className='wordBreak'>
                                {JSON.stringify(
                                  row.parameters.unbranded
                                ).replace(/["']/g, "")}
                              </span>
                            </TableCell>
                            <TableCell align='left'>
                              {row.note_text ? row.note_text : null}
                            </TableCell>
                          </TableRow>
                        ))
                      : null}
                      {
                        !selectScopedAnomalyRuleResponse.loading && currentRule.length===0?<TableRow
                        style={{ height: 10 }}
                      >
                        <TableCell colSpan={5}>
                         No data found
                        </TableCell>
                      </TableRow>:null
                      }
                  </TableBody>
                </Table>
                <FooterPagination
                  page={page}
                  handleChange={handleChange}
                  rulesPerPage={rulesPerPage}
                  totalRules={filteredData.length}
                  paginate={paginate}
                />
              </TableContainer>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      <Grid item md={3} className='helpBlock'>
        <Paper className={classes.containerPaper}>
          <Box component='div' className='helpBlockTitle'>
            Help
          </Box>

          <Box component='div' className='helpBlockImg'>
            <img
              src={HelpBlockImg}
              alt='HelpBlockImg'
              className='img-fluid'
              style={{ display: "block", margin: "auto", width: "100%" }}
            />
          </Box>
        </Paper>
      </Grid>

      {scopedAnomalyOpen && (
        <CreateScopedAnomalyRule
          handleScopedAnomalyDialog={handleScopedAnomalyDialog}
          scopedAnomalyOpen={scopedAnomalyOpen}
          ruleId={anomalyRuleId}
          createSuccessFlag={createSuccessFlag}
        />
      )}
      {createSuccess && <CreateSuccessDialog />}

      {/* Rendering Edit Finding Rule Component */}
      {editScopedAnomalyRule && (
        <EditScopedAnomalyRule
          open={editScopedAnomalyRule}
          dataToEdit={dataToEdit}
          onClose={(e) => handleClose()}
          setEditScopedAnomalySuccess={setEditScopedAnomalySuccess}
          setEditScopedAnomalyFailure={setEditScopedAnomalyFailure}
        />
      )}
      <Snackbar
          message={"Scoped Anomaly Rule successfully updated"}
          open={updateSuccess ? true : false}
          onClose={() => setUpdateSuccess(false)}
          autoHideDuration={2000}
        />
      {/* Rendering Edit Success dialog */}
      {editScopedAnomalySuccess && (
        <Grid>
      <Dialog
        open={editScopedAnomalySuccess}
        maxWidth={'md'}
        PaperProps={{ style: { width: '40em', height: '20em' } }}
      >
        <DialogContent style={{ padding: '30px' }}>
          <Grid
            item
            container
            direction='column'
            justifyContent='center'
            alignItems='center'
          >
            <Grid item>
              <CheckCircleOutlineIcon
                style={{ width: '3em', height: '3em', color: '#52A1C2' }}
              />
            </Grid>
            <Grid item style={{ marginTop: '20px', marginBottom: '20px' }}>
              Selected Scoped Anomaly Rule has been edited successfully
            </Grid>
            <Grid item>
              <Button
                onClick={() => handleUpdateSuccess()}
                variant='outlined'
              >
                <Typography>OK</Typography>
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </Grid>
      )}
      <DeleteConfirmDialog
              open={openDelete}
              handleDelete={handleDelete}
              message={' Do you want to delete this Scoped Anomaly Rule?'}
              handleConfirm={handleConfirm}
            />
          <Snackbar
          message={"Scoped Anomaly Rule deleted successfully"}
          open={deleteSuccess ? true : false}
          onClose={() => setDeleteSuccess(false)}
          autoHideDuration={3000}
        />
    </Grid>
  );
};

export default function SelectScopedAnomalyRule() {
  useEffect(()=>{
    if(!history.location.search)
    {
      history.push('/rules');
      return;
    }
  },[])
  
  return (
    <Suspense fallback=''>
      <SelectScopedAnomalyRuleComponent />
    </Suspense>
  );
}
